const reloadBtn = document.querySelector('#btn-holder .reload-btn-js')

reloadBtn.addEventListener('click', () => {
  window.location.href = window.location.href;
});

var audios = new Audio(check_operation);
audios.load();
const video = document.querySelector('#btn-holder .check_operation_btn')
video.addEventListener('click', () => {
    if ($("#modal-overlay")[0]) $("#modal-overlay").remove();
    var imgstr = '<div id=\"modal-overlay\"><div id=\"modal-content\">' +
        '<img class="main_x_img" src="/files/items/radio_gymnastics/close.png">' +
        `<video class="check_operation_video" src='${check_operation}' type="video/mp4" autoplay muted>` +
        '</div></div>';
    $("body").append(imgstr);
    $("#modal-overlay").fadeIn("slow");
    mutedAllMedia();
    centeringModalSyncer() ;
    $('#sliderToggle').trigger('click');
    audios.play();
});
audios.addEventListener('ended', (event) => {
    $('#modal-overlay').remove() ;
    unMutedAllMedia();
});

function mutedAllMedia() {
  if (window.swiper) {
    window.swiper.mutedMovies();
  }
}

function unMutedAllMedia() {
  if (window.swiper) {
    window.swiper.unMutedMovies();
  }
}

function centeringModalSyncer() {
    var w = $( window ).width() ;
    var h = $( window ).height() ;
    var cw = $( "#modal-content" ).outerWidth( { margin:true } );
    var ch = $( "#modal-content" ).outerHeight( { margin:true } );
    var cw = $( "#modal-content" ).outerWidth();
    var ch = $( "#modal-content" ).outerHeight();
    $( "#modal-content" ).css( {"left": ((w - cw)/2) + "px","top": ((h - ch)/2) + "px"} ) ;
}

$(function() {
    $(document).on("click", "#modal-overlay, .main_x_img", function() {
        $( "#modal-content, #modal-overlay" ).fadeOut( "slow" , function(){
            $('#modal-overlay').remove() ;
            audios.pause();
            audios.currentTime = 0;
            unMutedAllMedia();
        });
    });
});

$(function () {
  $('#btn-holder .menu-group').each((index, btnGroup) => {
    $btnGroup = $(btnGroup)
    // スイッチが一つもなければグループを削除する
    if ($btnGroup.find('.commonContents').children().length === 0) {
      $btnGroup.remove()
    }
  })
})
